import gql from 'graphql-tag';

export const GET_VP_SETTINGS = gql`
  query GetVendorProfileSettings($dynamicsId: ID) {
    vendorProfile(dynamicsId: $dynamicsId) {
      id
      ocaShowCookieConsentBanner
    }
  }
`;
